const GREETING = "Hi! 👋 Need help shipping your pet?"

export type LiveChatMode = "live" | "offline"

export interface LiveChatAvailabilityPolicy {
  mode: LiveChatMode
  hide_when_offline: boolean
}

export const LIVE_CHAT_COPY = {
  liveLauncher: "Chat with us",
  offlineLauncher: "Create a ticket",
  contact: "Contact support",
  opening: "Opening chat…",
  start: "Start a conversation",
  greeting: GREETING,
  liveAction: "Speak to a real person",
  welcome: `${GREETING} A team member will be with you shortly!`,
} as const

const LIVE_CHAT_ROUTES: ReadonlySet<string> = new Set([
  "/offers/pet-transportation",
  "/offers/pet-transportation-inf",
  "/offers/pet-ground-transportation-v6",
  "/offers/dog-transportation",
  "/offers/dog-transportation-inf",
  "/offers/dog-ground-transportation-v6",
])

export function isLiveChatRoute(path: string): boolean {
  const pathname = path.split(/[?#]/, 1)[0].replace(/\/+$/, "")

  return LIVE_CHAT_ROUTES.has(pathname)
}
